import { useEffect } from 'react';

interface Props {
  triggerKey?: string;
  onTrigger: () => void;
  type?: 'keypress' | 'keydown';
}

const ignoreElements = ['input', 'textarea'];

const useShortcut = ({ triggerKey = '', onTrigger, type = 'keypress' }: Props) => {
  useEffect(() => {
    if (triggerKey) {
      const eventHandler = (event: KeyboardEvent) => {
        if (
          event.key === triggerKey &&
          ignoreElements.indexOf(document.activeElement?.tagName.toLowerCase() || '') === -1
        ) {
          event.preventDefault();
          onTrigger();
        }
      };
      window.addEventListener(type, eventHandler);
      return () => window.removeEventListener(type, eventHandler);
    }
  }, [onTrigger]);
};

export default useShortcut;
